export default {
  categories: {
    trends: 'À la une',
    home: 'Accueil',
    popular: 'Les plus consultées',
    all: 'Toutes les vidéos',
    trends_recent_all: 'Dernières vidéos',
  },
  notFound: {
    title: 'Désolé, la page que vous avez demandée est introuvable!',
    go_back: "Retour à la page d'accueil",
  },
  buttons: {
    search: 'Rechercher',
    integrate: 'Share',
    see_more: 'Voir plus',
    accept: 'Accepter',
    see_less: 'Voir moins',
    copy: 'Copier',
    like:"J'aime",
    download:'Télécharger'

  },
  labels: {
    footer:
      "En poursuivant votre navigation sur notre site, vous acceptez l'utilisation de cookies destinés à améliorer les fonctionnalités du site.",
    description: 'Description',
    powered_by: 'Powered by',
    no_video: 'Pas de videos',
    loading: 'Chargement ...',
    search: 'Rechercher...',
    integrations: ' Intégrations',
    integrations_options: "options d'intégration",
    start_video_auto: 'Démarrer la lecture automatiquement',
    default_color: 'Couleur par défaut de player',
    start_at: 'Démarrer la lecture à',
    share_social: 'Partager sur les réseaux sociaux',
    downloads: 'Téléchargements',
    embedTitle: 'Code embed',
    permalink: 'Permalien',
  },
  titles: {
    video_duration: 'Durée de la video',
    suggestions: 'Suggestions',
  },
  menu: {
    home: 'Accueil',
    trends: 'À la une',
    popular: 'Les plus vues',
    all: 'Tout',
    allVideos: 'Toutes les videos',
  },
};



// WEBPACK FOOTER //
// ./src/i18n/fr_FR.js